import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { SurveysApi } from 'entities/Surveys'
import { type IResponseFullSurvey } from 'entities/Surveys/api/types'
import { useSurveysPageContext } from 'pages/surveys/context/surveysPageContext'
import { SurveyView } from 'pages/surveys/ui/SurveyView/SurveyView'

export const CreateSurvey = observer(() => {
  const { pageLayoutStore } = useSurveysPageContext()
  const { state } = useLocation()
  const [loading, setLoading] = useState(!!state?.response)
  const [response, setResponse] = useState<IResponseFullSurvey | undefined>(undefined)

  useEffect(() => {
    if (state?.response?.id) {
      const fetchSurvey = async () => {
        try {
          const { data } = await SurveysApi.getSurvey(Number(state.response.id))
          setResponse(data)
        } catch (e) {
          logger.error(e)
        } finally {
          setLoading(false)
        }
      }
      void fetchSurvey()
    }
  }, [])

  if (loading) {
    return <SpinnerLoader ariaLabel={'CreateSurvey'} />
  }

  return (
    <SurveyView
      pageLayoutStore={pageLayoutStore}
      response={response}
      isDuplicate={state?.isDuplicate}
    />
  )
})
